import React from 'react';

const Download = ({ downloadSection }) => {
  return (
    <section className="index-download-app container-block">
      <h2 className="index-download-app-heading">Download the App:</h2>
      <div className="index-download-app-links-horizontal">
        <a
          className="app-link"
          href={downloadSection.appLinks.iosLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <picture>
            <source
              srcSet={downloadSection.sourceImgWebp.iosSrcSet}
              type={downloadSection.sourceImgWebp.type}
            />
            <source
              srcSet={downloadSection.sourceImgPng.iosSrcSet}
              type={downloadSection.sourceImgPng.type}
            />
            <img
              src={downloadSection.sourceImgPng.iosImgSrc}
              alt={downloadSection.sourceImgPng.iosTitle}
              title={downloadSection.sourceImgPng.iosTitle}
            />
          </picture>
        </a>
        <a
          className="app-link"
          href={downloadSection.appLinks.playMarketLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <picture>
            <source
              srcSet={downloadSection.sourceImgWebp.gPlaySrcSet}
              type={downloadSection.sourceImgWebp.type}
            />
            <source
              srcSet={downloadSection.sourceImgPng.gPlaySrcSet}
              type={downloadSection.sourceImgPng.type}
            />
            <img
              className="app-link-img-android"
              src={downloadSection.sourceImgPng.gPlayImgSrc}
              alt={downloadSection.sourceImgPng.gPlayTitle}
              title={downloadSection.sourceImgPng.gPlayTitle}
              height="54px"
              width="166px"
            />
          </picture>
        </a>
      </div>
    </section>
  );
};

export default Download;
